import React from "react";
import logout from "../../assets/images/logout.svg";
import notification from "../../assets/images/notification.svg";
import messages from "../../assets/images/messages.svg";
import questions from "../../assets/images/question.svg";
import { Link } from "react-router-dom";


const CommonIcon = () => {

  const handleClick=()=>{
  console.log("working")
  }

  return (
    <>
      <div className="flex">
        <div className="ml-3">
          <Link to="/" alt="" onClick={handleClick}>
            <img src={questions} />
          </Link>
        </div>
        <div className="ml-3">
          <Link to="/" alt="" >
            <img src={notification} />
          </Link>
        </div>
        <div className="ml-3">
          <Link to="/" alt=""  >
            <img src={messages} />
          </Link>
        </div>
        <div className="ml-3">
          <Link to="/" alt=""  >
            <img src={logout} />
          </Link>
        </div>
      </div>
    </>
  );
};

export default CommonIcon;
